import {pxToRem} from '../../utills/pxToRem'
import sizes from '../../theme/foundations/sizes'
import colors from '../../theme/foundations/colors'
import {fonts} from '../../theme/foundations/fonts'

const {md} = sizes.container

export const contentStyle = {
    padding: `${pxToRem(10)} ${pxToRem(5)}`,

    [`@media (min-width: ${md})`]: {
        border: `1px solid ${colors.cav_gainsboro}`
    },

    '.leftnav-accordion-item': {
        '.leftnav-accordion-title': {
            fontSize: pxToRem(14),
            textTransform: 'uppercase',
            lineHeight: pxToRem(22),
            background: 'cav_light_gray',
            color: 'cav_light_black',
            padding: pxToRem(10),
            letterSpacing: pxToRem(1.68),
            fontFamily: fonts.primary,
            fontWeight: 700,
            position: 'relative',
            display: 'flex',
            justifyContent: 'space-between',
            cursor: 'pointer',
            '.leftnav-accordion-title-btn': {
                position: 'static',
                fontSize: pxToRem(15),
                textAlign: 'center',
                width: pxToRem(20)
            }
        },
        '.leftnav-accordion-content': {
            ul: {
                listStyle: 'none',
                lineHeight: pxToRem(25),
                paddingLeft: pxToRem(10),
                paddingBottom: pxToRem(15),
                [`@media (max-width: ${md})`]: {
                    paddingLeft: pxToRem(30)
                },
                a: {
                    textDecoration: 'none',
                    fontFamily: fonts.primary,
                    fontSize: pxToRem(14),
                    color: 'cav_light_black',
                    '&:hover': {
                        color: 'cav_hover_brightred'
                    }
                }
            }
        }
    }
}
